<template>
  <div>
    <el-card  :class="{ 'hide-body': !showFilters }">
      <div slot="header" class="d-flex space-between">
        <h3>Reporte de  N&oacute;minas</h3>
        <el-button size="mini" plain @click="showFilters = !showFilters">
          <i v-if="!showFilters" class="icon el-icon-arrow-down "></i>
          <i v-if="showFilters" class="icon el-icon-arrow-up "></i>
        </el-button>
      </div>
      <el-row :gutter="10" v-if="showFilters">
        <el-col :md="12">
          <el-select v-model="filters.payroll_id"
                     @change="onChangeOption()"
                     placeholder="Seleccionar Planilla"
                     style="width: 100%">
            <el-option
              v-for="item in payrolls"
              :key="item.id"
              :label="item.name"
              :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.type }}</span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="12">
          <el-select v-model="filters.report"
                     :placeholder="loadingReports ? 'Cargando...' : 'Seleccionar Periodo'"
                     style="width: 100%">
            <el-option
              v-for="item in reportDates"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px" v-if="!isCoordinator">
        <el-col :md="12">
            <el-input placeholder="# Envio" v-model="filters.envio"
                             :min="0"
                             label="Envio"
                             style="width: 100%;">
            </el-input>
        </el-col>
        <el-col :md="12">
          <el-input placeholder="Concepto" v-model="filters.concept"
                    :min="0"
                    label="Concepto"
                    style="width: 100%;">
          </el-input>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-top: 20px" v-if="showFilters">
        <el-col :md="24">
          <el-button type="primary" :disabled="!validForm()" @click="loadReports()" :loading="loading" plain>Cargar Datos</el-button>
          <el-button type="success" :disabled="!validForm()" @click="exportReport()" :loading="exporting" plain>Exportar</el-button>
          <el-dropdown @command="handleCommand" v-if="!isCoordinator">
            <el-button type="danger" :disabled="!validForm()">
              Exportar BAC<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="a" :loading="exporting" >PRN</el-dropdown-item>
              <el-dropdown-item command="b" :loading="exporting" >Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown @command="handleCommand" v-if="!isCoordinator">
            <el-button type="primary" :disabled="!validForm()">
              Exportar Nacional<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="c" :loading="exporting" >ENV</el-dropdown-item>
              <el-dropdown-item command="d" :loading="exporting" >Excel</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="warning" :disabled="!validForm()" @click="exportOtherXLS()" v-if="!isCoordinator" :loading="exporting" plain>Otros Bancos</el-button>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="card-table">
      <div slot="header" class="card-header clearfix">
        <el-input type="search" placeholder="Buscar"
                  v-model="search"
                  @input="searchInTable"></el-input>
      </div>
    </el-card>
    <el-tabs type="border-card" style="margin-top: 30px" v-loading="loading">
      <el-tab-pane label="Reporte" id="report">
        <div id="hot-preview">
          <HotTable :root="root" :settings="tableSettings" ref="myHotTableRef"></HotTable>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Reporte General">
        <el-table
          :data="generalReport"
          :summary-method="getSummariesGeneralReport"
          show-summary
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Centro de costo">
          </el-table-column>
          <el-table-column
            prop="sum_net_salary"
            label="Total Salario Bruto">
          </el-table-column>
          <el-table-column
            prop="sum_finally_salary"
            label="Total Salario Neto">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import HotTable from '@handsontable/vue'
  import {baseApi} from '../../configs/urls'
  import {params, parseError} from '../../packages/Helpers'
  import {saveAs} from 'file-saver'
  export default {
    name: 'liquidation-report',
    components: {
      HotTable
    },
    data () {
      const _this = this
      return {
        root: 'test-hot',
        showFilters: true,
        data: [],
        search: '',
        tableSettings: {
          data: [],
          columns: [],
          colHeaders: [],
          fixedColumnsLeft: 3,
          height: 600,
          manualColumnFreeze: true,
          allowInsertColumn: false,
          allowInsertRow: false,
          contextMenu: {
            items: {
              'remove_row': {
                name: 'Eliminar Registro',
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.deleteRow(rowNumber, row.id)
                  }
                }
              },
              'send_email': {
                name: 'Enviar Comprobante de pago',
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.sendEmail(rowNumber, row.id)
                  }
                }
              },
              'unblock': {
                name: 'Desbloquear planilla',
                hidden: () => {
                  const role = (element) => element.name !== 'superadmin'
                  return this.$store.state.auth.roles.some(role)
                },
                callback: function (param1, param2) {
                  if (param2.length > 0 && param2[0].end.row === param2[0].start.row) {
                    const rowNumber = this.getSelected()[0][0]
                    const row = this.getSourceDataAtRow(rowNumber)
                    _this.unblocked(row.id)
                  }
                }
              }
            }
          }
        },
        exporting: false,
        columnsMeta: [],
        loadingPayRolls: false,
        payrolls: [],
        filters: {
          envio: '',
          concept: ''
        },
        loadingReports: false,
        reportDates: [],
        loading: false,
        generalReport: []
      }
    },
    methods: {
      searchInTable () {
        if (this.search !== '') {
          const searchables = this.columnsMeta.filter(meta => meta.search === true)
            .map(item => item.key)

          const data = this.copyData(this.data)
          this.tableSettings.data = data.filter((item) => {
            for (let key in item) {
              if (item.hasOwnProperty(key) && searchables.indexOf(key) >= 0) {
                if (item[key].toString().toLowerCase().includes(this.search.toLowerCase())) {
                  return true
                }
              }
            }
            return false
          })
        } else {
          this.tableSettings.data = this.copyData(this.data)
        }
      },
      copyData (data) {
        return [...data]
      },
      handleCommand (command) {
        console.log(command)
        switch (command) {
          case 'a': this.exportPRN()
            break
          case 'b': this.exportPRNXLS()
            break
          case 'c': this.exportENV()
            break
          case 'd': this.exportENVXLS()
            break
        }
      },
      validForm () {
        if (this.filters.payroll_id && this.filters.report) {
          return true
        }
        return false
      },
      getBaseData () {
        let data = {
          payroll_id: this.filters.payroll_id
        }

        let result = this.reportDates.filter((item) => {
          return item.value === this.filters.report
        })
        if (result.length > 0) {
          data.init_date = result[0].init_date
          data.end_date = result[0].end_date
        }
        return data
      },
      getPRNData () {
        let data = this.getBaseData()
        data.envio = this.filters.envio
        data.concept = this.filters.concept
        return data
      },
      onChangeOption () {
        if (this.filters.payroll_id) {
          this.reportDates = []
          this.loadingReports = true
          const data = {
            payroll_id: this.filters.payroll_id,
            confirmed: true
          }
          this.$http.get(baseApi + '/reports' + params(data))
            .then(
              (response) => {
                this.reportDates = response.body
                this.loadingReports = false
              },
              (res) => {
                this.$message.error(parseError(res)[0])
                this.loadingReports = false
              }
            )
        }
      },
      loadReports () {
        if (!this.validForm()) {
          this.$message.error('Verifica que esten todos los campos llenos.')
          return
        }

        const data = this.getBaseData()

        this.tableSettings.data = []
        this.loading = true
        this.$http.get(baseApi + '/reports/confirmed' + params(data))
          .then(
            (response) => {
              const data = response.body
              const params = data.params
              this.columnsMeta = params

              this.columnsMeta = Object.keys(params).map((param) => {
                let output = Object.assign({}, params[param])
                output.key = param
                return output
              })

              let columns = []
              let headers = data.headers
              if (data.data.length > 0) {
                columns = headers.map((key) => {
                  let output = {
                    data: key.replace(/ /g, '_'),
                    readOnly: true
                  }

                  let result = null
                  for (let index in params) {
                    if (index && params.hasOwnProperty(index) && index === output.data && params[index].formula) {
                      result = params[index]
                      break
                    }
                  }

                  if (result) {
                    output.type = 'numeric'
                    output.numericFormat = {
                      pattern: '0.00'
                    }
                  }

                  return output
                })
              }

              this.tableSettings.data = data.data
              this.data = this.copyData(data.data)
              this.tableSettings.columns = columns
              this.tableSettings.colHeaders = headers
              this.generalReport = data.general_report
              this.loading = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loading = false
            }
          )
      },
      exportReport () {
        const data = this.getBaseData()
        let url = baseApi + '/reports/excel'
        this.exporting = true
        this.$http.post(url, data, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportPRN () {
        const data = this.getPRNData()
        let url = baseApi + '/reports/prn' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'text/plain'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.PRN')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportPRNXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/reports/prne' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina BAC'

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      showTestKey (testKey) {
        this.$alert(`Se ha generado el archivo, para la confirmación necesitara el <br/><big><b> Test Key ${testKey}</b></big><br/>favor tomar nota de este codigo`, 'BTL VISOR', {
          confirmButtonText: 'Aceptar',
          dangerouslyUseHTMLString: true
        })
      },
      exportENV () {
        const data = this.getPRNData()
        let url = baseApi + '/reports/env' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          headers: {'Accept': 'text/plain'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data.content], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina '

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.env')
              this.showTestKey(response.data.testKey)
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportENVXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/reports/enve' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nomina BNCR'

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.exporting = false
            }
          )
      },
      exportOtherXLS () {
        const data = this.getPRNData()
        let url = baseApi + '/reports/other' + params(data)
        this.exporting = true
        this.$http.post(url, {}, {
          responseType: 'arraybuffer',
          headers: {'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
        })
          .then(
            (response) => {
              const blob = new Blob([response.data], {type: 'application/octet-stream'})
              const payrolls = this.payrolls.filter((item) => {
                return item.id === this.filters.payroll_id
              })
              let filename = 'nominaOtrosBancos'

              if (payrolls.length > 0) {
                filename += payrolls[0]['name'] + ' '
              }

              filename += data.init_date + ' ' + data.end_date
              saveAs(blob, filename + '.xlsx')
              this.exporting = false
            },
            (res) => {
              this.$message.error('No se puede descargar')
              this.exporting = false
            }
          )
      },
      deleteRow (row, id) {
        this.loading = true

        if (!id) {
          this.loading = false
          return
        }

        this.$http.delete(baseApi + '/reports/' + id, id)
          .then(
            () => {
              this.loading = false
              this.data = this.data.filter(item => item.id !== id)
              this.$refs.myHotTableRef.hotInstance.alter('remove_row', row, 1)
            },
            (res) => {
              this.$message.error('Ocurrio un error al intentar eliminar una linea ')
              this.loading = false
            }
          )
      },
      unblocked (id) {
        if (!id) {
          return
        }
        this.loading = true
        this.$http.get(baseApi + '/reports/unblocked/' + id, id)
          .then(
            () => {
              this.loading = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loading = false
            }
          )
      },
      sendEmail (row, id) {
        this.loading = true

        if (!id) {
          this.loading = false
          return
        }

        this.$http.get(baseApi + '/reports/' + id, id)
          .then(
            () => {
              this.loading = false
            },
            (res) => {
              this.$message.error('Ocurrio un error al enviar el correo electronico')
              this.loading = false
            }
          )
      },
      getSummariesGeneralReport (params) {
        return [
          'Total',
          params.data.reduce((prev, current) => parseFloat(current.sum_net_salary) + prev, 0),
          params.data.reduce((prev, current) => parseFloat(current.sum_finally_salary) + prev, 0)
        ]
      }
    },
    mounted () {
      this.loadingPayRolls = true
      this.$http.get(baseApi + '/payrolls')
        .then(
          (response) => {
            this.payrolls = response.body
            this.loadingPayRolls = false
          },
          (res) => {
            this.$message.error(parseError(res)[0])
            this.loadingPayRolls = false
          }
        )
    },
    computed: {
      isCoordinator () {
        return this.$store.state.auth.roles &&
          this.$store.state.auth.roles.length > 0 &&
          this.$store.state.auth.roles[0].name === 'coordinator'
      }
    }
  }
</script>
<style>
  .el-card {
    margin-top: 30px
  }

  .el-card:last-child {
    margin-bottom: 100px
  }

  h3 {
    margin: 0
  }

  #test-hot td {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  #test-hot .ht_clone_left td,
  #test-hot .ht_clone_top_left_corner td {
    height: auto !important;
  }
  .el-tabs--border-card > .el-tabs__content {
    padding: 0px;
  }
</style>
<style src="handsontable/dist/handsontable.full.css"></style>



// WEBPACK FOOTER //
// src/views/reports/LiquidationReport.vue